import TopParts from './TopParts';
import TopPart from './TopPart';



Vue.component(TopParts.name, TopParts);
Vue.component(TopPart.name, TopPart);



// WEBPACK FOOTER //
// ./src/js/top/components/index.js